module.exports = "/_next/static/images/StayingAheadOfTheCurve-xs-e5abdac8aea271ea4d26411f8b6b5114.png";